<template>
  <div class="divBox">
    <el-card :bordered="false" dis-hover class="ivu-mt">
      <el-form ref="artFrom" :model="thisForm" size="small" inline label-position="right" @submit.native.prevent>
        <el-form-item label="关键字搜索：" label-for="nickname">
          <el-input
            placeholder="请输入搜索关键字"
            v-model="thisForm.keyword"
            class="input-with-select"
            @keyup.enter.native="searchs"
          >
            <el-select v-model="thisForm.fieldKey" style="width: 80px" slot="prepend" placeholder="请选择">
              <el-option label="全部" value="all"></el-option>
              <el-option label="技师账号" value="login_name"></el-option>
              <el-option label="技师姓名" value="name"></el-option>
              <el-option label="联系电话" value="phone"></el-option>
            </el-select>
            <el-button type="primary" slot="append" icon="el-icon-search" @click="searchs"></el-button>
          </el-input>
        </el-form-item>

        <el-form-item label="城市筛选" label-for="cityId">
          <el-select v-model="thisForm.cityId" @change="searchs" clearable placeholder="请选择城市">
            <el-option
              v-for="city in cityOptions"
              :key="city.id"
              :label="city.cityName"
              :value="city.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否推荐" label-for="isRecommend">
          <el-select v-model="thisForm.isRecommend" @change="searchs" clearable>
            <el-option :value="1" label="是"></el-option>
            <el-option :value="0" label="否"></el-option>
          </el-select>
        </el-form-item>
        <!--        <el-form-item>-->
        <!--          <el-button type="primary" size="small" @click="searchs">查询</el-button>-->
        <!--        </el-form-item>-->
        <el-row type="flex">
          <el-button type="primary" class="mr20" @click="add" icon="md-add">添加技师</el-button>
        </el-row>
        <div style="width: 100%; overflow-x: auto; overflow-y: visible;">
          <el-table :data="list" ref="table" class="mt25" v-loading="loading" size="small">
          <el-table-column prop="id" label="ID" width="60"></el-table-column>
          <el-table-column label="技师头像">
            <template slot-scope="{ row, index }">
              <el-image
                v-if="row.thumb"
                style="width: 100px; height: 100px"
                :src="row.thumb"
                :preview-src-list="[row.thumb]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <!-- <el-table-column prop="loginName" label="登录帐号"></el-table-column> -->
          <!-- <el-table-column label="绑定用户" prop="oprate" min-width="150">
            <template slot-scope="{ row, index }">
              <div v-if="row.uid > 0" style="display: flex">
                <el-image
                  v-if="row.avatar"
                  style="width: 100px; height: 100px"
                  :src="row.avatar"
                  :preview-src-list="[row.avatar]"
                ></el-image>
                <div style="margin-left: 5px">
                  <div>UID：{{ row.uid }}</div>
                  <div>昵称：{{ row.nickName }}</div>
                </div>
              </div>
              <div v-else style="color: #cccccc">未绑定</div>
            </template>
          </el-table-column> -->
          <!-- <el-table-column label="是否培训">
             <template slot-scope="{ row }">
              {{ row.isTraining === 1 ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column label="是否模拟">
             <template slot-scope="{ row }">
              {{ row.isMock === 1 ? '是' : '否' }}
            </template>
          </el-table-column> -->
          <el-table-column label="所属城市">
            <template slot-scope="{ row }">
              {{ getCityName(row.cityId) }}
            </template>
          </el-table-column>
         
          <el-table-column prop="place" label="接单地址"></el-table-column>
          <el-table-column prop="serviceRadius" label="接单距离(km)"></el-table-column>

          <el-table-column label="是否推荐">
            <template slot-scope="{ row, index }">
              <el-switch
                v-model="row.isRecommend"
                :active-value="1"
                :inactive-value="0"
                @change="changeIsRecommend(row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="是否接单">
            <template slot-scope="{ row, index }">
              <el-switch
                v-model="row.workStatus"
                :active-value="1"
                :inactive-value="0"
                @change="changeIsWork(row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="是否启用">
            <template slot-scope="{ row, index }">
              <el-switch
                v-model="row.status"
                :active-value="1"
                :inactive-value="0"
                @change="changeStatus(row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="operate" fixed="right" min-width="200">
            <template slot-scope="{ row, index }">
              <el-button type="text" @click="getStaffRelate(row)" style="color: #409EFF;">项目设置</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button type="text" @click="edit(row)" style="color: #409EFF;">修改</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button type="text" @click="openScheduling(row)" style="color: #409EFF;">排班</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button type="text" @click="updateOrderCount(row)" style="color: #409EFF;">订单数量</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button type="text" @click="openSimulateComment(row)" style="color: #409EFF;">模拟评论</el-button>
            </template>
          </el-table-column>
        </el-table></div>
        <div class="block">
          <el-pagination
            background
            :page-size="thisForm.limit"
            :current-page="thisForm.page"
            :total="total"
            :page-sizes="[20, 40, 60, 80]"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="pageChange"
          />
        </div>
      </el-form>
    </el-card>
    <edit-form ref="editForms" @submitOk="submitOk"></edit-form>
    <service-item ref="serviceItems" @submitOk="submitOk"></service-item>
    <scheduling ref="scheduling" @scheduleUpdated="getList"></scheduling>
    
    <!-- 模拟评论对话框 -->
    <el-dialog title="创建技师模拟评论" :visible.sync="simulateCommentVisible" width="600px">
      <el-form :model="simulateCommentForm" :rules="simulateCommentRules" ref="simulateCommentForm" label-width="120px">
        <el-form-item label="技师姓名：">
          <span>{{ simulateCommentForm.staffName }}</span>
        </el-form-item>
        <el-form-item label="评论昵称：" prop="nickname">
          <el-input v-model="simulateCommentForm.nickname" placeholder="请输入评论昵称" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="服务分数：" prop="serviceScore">
          <el-rate v-model="simulateCommentForm.serviceScore" :max="5" show-text></el-rate>
        </el-form-item>
        <el-form-item label="评论内容：" prop="content">
          <el-input 
            v-model="simulateCommentForm.content" 
            type="textarea" 
            :rows="4" 
            placeholder="请输入评论内容"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="评价标签：">
          <el-input v-model="simulateCommentForm.serviceLabel" placeholder="多个标签用逗号分隔，如：服务好,态度好" maxlength="200"></el-input>
        </el-form-item>
        <el-form-item label="晒图：">
          <el-input v-model="simulateCommentForm.images" placeholder="多个图片URL用逗号分隔" maxlength="500"></el-input>
        </el-form-item>
        <el-form-item label="评论时间：">
          <el-date-picker
            v-model="simulateCommentForm.commentTime"
            type="datetime"
            placeholder="选择评论时间"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          >
          </el-date-picker>
          <div style="color: #909399; font-size: 12px; margin-top: 5px;">
            不选择则为当前时间
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="simulateCommentVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitSimulateComment" :loading="simulateCommentLoading">确 定</el-button>
      </span>
    </el-dialog>
    
    <!-- 修改订单数量对话框 -->
    <el-dialog title="修改技师订单数量" :visible.sync="orderCountVisible" width="500px">
      <el-form :model="orderCountForm" label-width="120px">
        <el-form-item label="技师姓名：">
          <span>{{ orderCountForm.name }}</span>
        </el-form-item>
        <el-form-item label="调整数量：" required>
          <el-input-number 
            v-model="orderCountForm.orderCountAdjust" 
            :min="-9999" 
            :max="9999"
            placeholder="请输入调整数量"
            style="width: 100%"
          ></el-input-number>
          <div style="color: #909399; font-size: 12px; margin-top: 5px;">
            正数为增加，负数为减少
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderCountVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitOrderCount" :loading="orderCountLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import editForm from './handle/editForm';
import serviceItem from './handle/serviceItem';
import scheduling from './handle/scheduling';
import {
  getServiceStaffList,
  setStaffIsRecommend,
  setStaffIsWork,
  setStaffStatus,
  serviceStaffDelApi,
  getCityOptions,
  createServiceStaff,
  createSimulateCommentApi,
  updateServiceStaffOrderCountApi,
} from '@/api/technician';

export default {
  name: 'service_staff',
  components: { editForm, serviceItem, scheduling },
  data() {
    return {
      grid: {
        xl: 7,
        lg: 7,
        md: 12,
        sm: 24,
        xs: 24,
      },
      thisForm: {
        page: 1,
        limit: 20,
        keyword: '',
        fieldKey: 'all',
        isRecommend: '',
        cityId: '',
      },
      list: [],
      loading: false,
      total: 0,
      cityOptions: [],
      orderCountVisible: false,
      orderCountLoading: false,
      orderCountForm: {
        id: 0,
        name: '',
        orderCountAdjust: 0,
      },
      simulateCommentVisible: false,
      simulateCommentLoading: false,
      simulateCommentForm: {
        serviceStaffId: 0,
        staffName: '',
        nickname: '',
        serviceScore: 5,
        content: '',
        serviceLabel: '',
        images: '',
        commentTime: '',
      },
      simulateCommentRules: {
        nickname: [
          { required: true, message: '请输入评论昵称', trigger: 'blur' },
        ],
        serviceScore: [
          { required: true, message: '请选择服务分数', trigger: 'change' },
        ],
        content: [
          { required: true, message: '请输入评论内容', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    ...mapState('media', ['isMobile']),
    labelWidth() {
      return this.isMobile ? undefined : 100;
    },
    labelPosition() {
      return this.isMobile ? 'top' : 'right';
    },
  },
  created() {
    this.getCityOptions();
    this.getList();
  },
  methods: {
    // 打开排班
    openScheduling(row) {
      this.$refs.scheduling.openScheduling(row);
    },
    // 添加
    add() {
      this.$refs.editForms.reset();
      this.$refs.editForms.getCityOption();
      this.$refs.editForms.getServiceLabel();
      this.$refs.editForms.getStaffCateOption();
      this.$refs.editForms.open_modal = true;
    },
    // 列表
    getList() {
      this.loading = true;
      getServiceStaffList(this.thisForm)
        .then(async (data) => {
          console.log('列表', data);
          this.total = data.data.total;
          this.list = data.data.list;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.msg);
        });
    },
    // 执行完后刷新
    submitOk() {
      this.getList();
    },
    // 分页
    pageChange(index) {
      this.thisForm.page = index;
      this.getList();
    },
    handleSizeChange(val) {
      this.thisForm.limit = val;
      this.getList();
    },
    // 修改
    edit(row) {
      this.$refs.editForms.reset();
      this.$refs.editForms.getCityOption();
      this.$refs.editForms.getServiceLabel();
      this.$refs.editForms.getStaffCateOption();
      this.$nextTick(() => {
        this.$refs.editForms.getInfo(row.id);
        // 从列表数据中设置 isMock 和 isTraining 值
        this.$refs.editForms.setMockAndTrainingValues(row.isMock, row.isTraining);
        this.$refs.editForms.open_modal = true;
      });
    },
    // 删除
    del(row, tit) {
      this.loading = true;
      this.$modalSure('是否删除此技师')
        .then(() => {
          serviceStaffDelApi({ id: row.id }).then((res) => {
            this.loading = false;
            this.$message.success('删除成功');
            this.getList();
          });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 人员服务项目
    getStaffRelate(row) {
      this.$refs.serviceItems.open_modal = true;
      this.$refs.serviceItems.thisForm.staffId = row.id;
      this.$nextTick(() => {
        this.$refs.serviceItems.getList();
      });
    },
    // 搜索
    searchs() {
      this.thisForm.page = 1;
      this.getList();
    },
    // 设置状态
    changeIsRecommend(row) {
      setStaffIsRecommend({ id: row.id, is_recommend: row.isRecommend })
        .then((res) => {
          this.$message.success('提交成功');
          this.getList();
        })
        .catch((res) => {
          this.$message.error(res.msg);
        });
    },
    changeIsWork(row) {
      setStaffIsWork({ id: row.id, workStatus: row.workStatus })
        .then((res) => {
          this.$message.success('提交成功');
          this.getList();
        })
        .catch((res) => {
          this.$message.error(res.msg);
        });
    },
    changeStatus(row) {
      setStaffStatus({ id: row.id, status: row.status })
        .then((res) => {
          this.$message.success('提交成功');
          this.getList();
        })
        .catch((res) => {
          this.$message.error(res.msg);
        });
    },
    // changeIsMock(row) {
    //   const updateData = {
    //     id: row.id,
    //     isMock: row.isMock
    //   };
    //   createServiceStaff(updateData)
    //     .then((res) => {
    //       this.$message.success('提交成功');
    //       this.getList();
    //     })
    //     .catch((res) => {
    //       this.$message.error(res.msg);
    //     });
    // },
    // changeIsTraining(row) {
    //   const updateData = {
    //     id: row.id,
    //     isTraining: row.isTraining
    //   };
    //   createServiceStaff(updateData)
    //     .then((res) => {
    //       this.$message.success('提交成功');
    //       this.getList();
    //     })
    //     .catch((res) => {
    //       this.$message.error(res.msg);
    //     });
    // },
    // 修改订单数量
    updateOrderCount(row) {
      this.orderCountForm = {
        id: row.id,
        name: row.name,
        orderCountAdjust: 0,
      };
      this.orderCountVisible = true;
    },
    // 提交订单数量修改
    submitOrderCount() {
      if (!this.orderCountForm.orderCountAdjust) {
        return this.$message.warning('请输入调整数量');
      }
      this.orderCountLoading = true;
      updateServiceStaffOrderCountApi(this.orderCountForm.id, this.orderCountForm.orderCountAdjust)
        .then((res) => {
          this.orderCountLoading = false;
          this.$message.success('修改成功');
          this.orderCountVisible = false;
          this.getList();
        })
        .catch((err) => {
          this.orderCountLoading = false;
          this.$message.error(err.msg || '修改失败');
        });
    },
    // 获取城市选项
    getCityOptions() {
      getCityOptions().then(data => {
        console.log("获取城市列表", data);
        this.cityOptions = data.data || [];
      }).catch(err => {
        console.error('获取城市列表失败:', err);
        this.cityOptions = [];
      });
    },
    // 根据城市ID获取城市名称
    getCityName(cityId) {
      if (!cityId || !this.cityOptions.length) {
        return '未设置';
      }
      const city = this.cityOptions.find(item => item.id === cityId);
      return city ? city.cityName : '未知城市';
    },
    // 打开模拟评论对话框
    openSimulateComment(row) {
      this.simulateCommentForm = {
        serviceStaffId: row.id,
        staffName: row.name,
        nickname: '',
        serviceScore: 5,
        content: '',
        serviceLabel: '',
        images: '',
        commentTime: '',
      };
      this.simulateCommentVisible = true;
      this.$nextTick(() => {
        this.$refs.simulateCommentForm && this.$refs.simulateCommentForm.clearValidate();
      });
    },
    // 提交模拟评论
    submitSimulateComment() {
      this.$refs.simulateCommentForm.validate((valid) => {
        if (!valid) {
          return false;
        }
        
        const submitData = {
          serviceStaffId: this.simulateCommentForm.serviceStaffId,
          nickname: this.simulateCommentForm.nickname,
          serviceScore: this.simulateCommentForm.serviceScore,
          content: this.simulateCommentForm.content,
        };
        
        // 可选字段
        if (this.simulateCommentForm.serviceLabel) {
          submitData.serviceLabel = this.simulateCommentForm.serviceLabel;
        }
        if (this.simulateCommentForm.images) {
          submitData.images = this.simulateCommentForm.images;
        }
        if (this.simulateCommentForm.commentTime) {
          submitData.commentTime = this.simulateCommentForm.commentTime;
        }
        
        this.simulateCommentLoading = true;
        createSimulateCommentApi(submitData)
          .then((res) => {
            this.simulateCommentLoading = false;
            this.$message.success('模拟评论创建成功');
            this.simulateCommentVisible = false;
            this.getList();
          })
          .catch((err) => {
            this.simulateCommentLoading = false;
            this.$message.error(err.msg || '创建失败');
          });
      });
    },
  },
};
</script>

<style>
.treeSel >>> .ivu-select-dropdown-list {
  padding: 0 10px !important;
  box-sizing: border-box;
}

.tabBox_img {
  width: 36px;
  height: 36px;
  border-radius: 4px;
  cursor: pointer;
}

.tabBox_img img {
  width: 100%;
  height: 100%;
}

.el-select .el-input {
  width: 100px;
}

</style>
